import React from 'react';
import getVideoFeedUrl from 'helpers/feeds/videoHelpers';
import makeRequest from 'utils/makeRequest';
import PropTypes from 'prop-types';
import Video from 'components/Video/Video';
import { isTablet } from 'utils/common';
import { connect } from 'react-redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  openVideoTheatre,
  closeVideoTheatre,
  addNextVideoMsid,
  deleteDockCandidate,
  deleteUnDockCandidate,
} from 'routes/articleshow/redux';

import { showMiniTvPlayer } from 'modules/WithMiniTv/redux';
// eslint-disable-next-line no-unused-vars
import slickcss from '../../../../../../node_modules/slick-carousel/slick/slick.css';
import s from './VideoTheater.scss';
import VideoTheaterSlider from './VideoTheaterSlider';

function getNextVideosMsidArray(bottomVideosSliderData) {
  return bottomVideosSliderData.map(item => item.id);
}

class VideoTheater extends React.Component {
  constructor(props) {
    super(props);
    this.currArticleshowUrl = {
      wu: '',
      hl: '',
    };
    this.state = {
      bottomVideosSliderData: [],
      playingVideoItem: undefined,
      isVideoTheatreMinified: false,
      activeSlide: undefined,
      slikeNextVideoAutoPlayed: true,
    };
  }

  getSlikeIdFromMsid(msid) {
    let slikeId = '';
    const { bottomVideosSliderData } = this.state;
    for (let i = 0; i < bottomVideosSliderData.length; i += 1) {
      if (bottomVideosSliderData[i].id === msid) {
        slikeId = bottomVideosSliderData[i].playerId;
        break;
      }
    }
    return slikeId;
  }

  changeUrl() {
    const { playingVideoItem } = this.state;
    if (window.location.href.includes('/articleshow/')) {
      this.currArticleshow = {
        wu: window.location.href,
        hl: document.title,
      };
    }
    const newUrl = playingVideoItem
      ? playingVideoItem.wu.replace('https://timesofindia.indiatimes.com', '')
      : this.currArticleshow.wu;
    const newTitle = playingVideoItem
      ? playingVideoItem.hl
      : this.currArticleshow.hl;
    if (window.history && !(window.location.href.indexOf(newUrl) >= 0)) {
      try {
        window.history.pushState({}, newTitle, newUrl);
      } catch (e) {
        // console.error(e);
      }
      //fire page view
      if (
        typeof window !== 'undefined' &&
        newUrl.indexOf('/videoshow/') !== -1
      ) {
        if (window.TimesGA && window.TimesGA.setGAParams) {
          window.TimesGA.setGAParams({});
        }
        analyticsWrapper('gaAndGrx', 'send', {
          hitType: 'pageview',
          page: newUrl,
          location: newUrl,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      videoTheatreSliderPath,
      isVideoTheatreOpen,
      videoTheatreCurrMsid,
    } = this.props;
    const { isVideoTheatreMinified, activeSlide } = this.state;
    if (
      prevProps.isVideoTheatreOpen !== isVideoTheatreOpen &&
      !isVideoTheatreOpen
    ) {
      //When the theatre is closed
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isVideoTheatreMinified: false,
        playingVideoItem: undefined,
        activeSlide: undefined,
      });
    }
    if (prevProps.videoTheatreCurrMsid !== videoTheatreCurrMsid) {
      //When theatre docked, another video is clicked
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isVideoTheatreMinified: false,
      });
    }
    if (
      prevState.isVideoTheatreMinified !== isVideoTheatreMinified &&
      isVideoTheatreMinified
    ) {
      //closeMiniTv on Video Dock
      this.props.showMiniTvPlayer(false);
    }
    if (
      prevState.isVideoTheatreMinified !== isVideoTheatreMinified &&
      !isVideoTheatreMinified
    ) {
      //Removing body scroll on theatre mode
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = this.state.isVideoTheatreMinified ? 'hidden' : '';
    }
    if (
      isVideoTheatreOpen !== prevProps.isVideoTheatreOpen &&
      isVideoTheatreOpen
    ) {
      //Delete LeadVideo Dock on Video Theatre Open
      this.props.deleteDockCandidate();
      this.props.deleteUnDockCandidate();
    }
    if (
      isVideoTheatreOpen !== prevProps.isVideoTheatreOpen ||
      isVideoTheatreMinified !== prevState.isVideoTheatreMinified ||
      activeSlide !== prevState.activeSlide
    ) {
      //change Url on Rhs and trending videos
      this.changeUrl();
    }
    if (
      (prevProps.videoTheatreSliderPath !== videoTheatreSliderPath ||
        prevProps.videoTheatreCurrMsid !== videoTheatreCurrMsid) &&
      this.props.isVideoTheatreOpen
    ) {
      let url = videoTheatreSliderPath;
      if (
        videoTheatreSliderPath &&
        videoTheatreSliderPath.startsWith('https://')
      ) {
        // const regexForExtractingSectionUrl = /^(http\:|https\:)(\/\/timesofindia.indiatimes.com\/)(\D+)(\/\D+\/)(videoshow\/\d+.cms)$/;
        const tempUrl = videoTheatreSliderPath
          .replace('https://timesofindia.indiatimes.com/', '')
          .replace(/\/videoshow\/\d+.cms/, '')
          .split('/');
        tempUrl.pop();
        url = getVideoFeedUrl({
          path: `/${tempUrl.join('/')}`,
          perpage: 10,
        });
      } else {
        url = getVideoFeedUrl({
          path: videoTheatreSliderPath,
          perpage: 10,
        });
      }
      const tthis = this;
      makeRequest
        .get(url, { isMobile: this.props.isMobile })
        .then(videoSliderDataRes => {
          if (videoSliderDataRes.status === 200) {
            let videoData = [];
            if (
              videoSliderDataRes.data &&
              videoSliderDataRes.data.data &&
              videoSliderDataRes.data.data.items
            ) {
              videoData = videoSliderDataRes.data.data.items;
            } else if (
              videoSliderDataRes.data.sections &&
              videoSliderDataRes.data.sections[0] &&
              videoSliderDataRes.data.sections[0].data
            ) {
              videoData = videoSliderDataRes.data.sections[0].data.items;
            }

            let videoSliderObjToBePassed = videoData || [];
            if (
              videoSliderObjToBePassed &&
              videoSliderObjToBePassed.length > 10
            ) {
              videoSliderObjToBePassed = videoSliderObjToBePassed.slice(0, 10);
            }
            const currSlideId = this.props.videoTheatreCurrMsid;
            let currSlide = videoSliderObjToBePassed.filter(
              item => item.id === currSlideId,
            );
            if (currSlide.length === 0) {
              currSlide = [this.props.videoTheatreCurrItem];
              videoSliderObjToBePassed.unshift(this.props.videoTheatreCurrItem);
            }
            tthis.setState({
              bottomVideosSliderData: videoSliderObjToBePassed,
              playingVideoItem: currSlide ? currSlide[0] : undefined,
              activeSlide: currSlideId,
            });
          }
        });
    }
  }
  handleSliderCardItem = (e, clickedVideoItem) => {
    e.preventDefault();
    this.setState({
      playingVideoItem: clickedVideoItem,
      activeSlide: clickedVideoItem.id,
      slikeNextVideoAutoPlayed: false,
    });
  };
  handleClose = () => {
    this.setState({
      isVideoTheatreMinified: false,
      playingVideoItem: undefined,
      activeSlide: undefined,
    });
    this.props.closeVideoTheatre();
  };
  videoEventListener = (messageName, data) => {
    this.a = '';
    const videoEvent = data ? data[1] : '';
    let newMsid = '';
    let newSlikeId = '';
    let currentMsid = '';
    // let newUrl = '';
    const nextVideomsidArray = getNextVideosMsidArray(
      this.state.bottomVideosSliderData,
    );
    switch (videoEvent) {
      case 'VIDEOVIEW':
        newMsid = data && data.length > 2 && data[2];
        this.setState({
          slikeNextVideoAutoPlayed: true,
        });
        try {
          // newUrl = this.props.videoTheatreSliderData.filter(
          //   item => parseInt(item.id, 10) === parseInt(newMsid, 10),
          // )[0].link;
          // this.state.currentUrl = newUrl;
          // if (window.history && !(window.location.href.indexOf(newUrl) >= 0)) {
          //   window.history.pushState({}, 'abc', newUrl);
          // }
        } catch (err) {
          //console.log(err);
        }
        // console.log('VIDEOREADY', data, newMsid);
        // this.props.addNextVideoMsid(
        //   nextVideomsidArray[nextVideomsidArray.indexOf(newMsid) + 1],
        // );
        break;
      case 'VIDEOEND':
        currentMsid = this.state.activeSlide;
        newMsid =
          nextVideomsidArray[nextVideomsidArray.indexOf(currentMsid) + 1];
        newSlikeId = this.getSlikeIdFromMsid(newMsid);
        this.props.addNextVideoMsid(newMsid, newSlikeId);
        break;
      default:
      // console.log('messageName');
    }
  };
  render() {
    const { isUserPrime, isVideoTheatreOpen } = this.props;
    const { bottomVideosSliderData, playingVideoItem } = this.state;
    if (
      isVideoTheatreOpen &&
      bottomVideosSliderData.length !== 0 &&
      playingVideoItem
    ) {
      const imgElements = playingVideoItem.imageid.split('&');
      const tthis = this;
      const activeSlideData = bottomVideosSliderData.filter(
        item => item.id === this.state.activeSlide,
      );
      const activeSlideTitle =
        activeSlideData.length > 0 ? activeSlideData[0].hl : '';
      const primeId =
        this.props.videoTheatreCurrItem &&
        this.props.videoTheatreCurrItem.primeid
          ? parseInt(this.props.videoTheatreCurrItem.primeid, 10)
          : 0;
      const isContentPrime = primeId && primeId > 0;
      return (
        <div
          className={`${s.video_theatreoverlay} ${
            this.state.isVideoTheatreMinified ? s.theatreDocked : ''
          }`}
        >
          {!isTablet() && (
            <button
              className={s.dockicon}
              type="button"
              onClick={() => {
                this.setState({
                  isVideoTheatreMinified: !this.state.isVideoTheatreMinified,
                });
              }}
            />
          )}

          <button
            type="button"
            className={s.close}
            onClick={this.handleClose}
          />
          <Video
            autoplay
            slikeNextVideoAutoPlayed={this.state.slikeNextVideoAutoPlayed}
            videoClassName={s.video_theatrevideo}
            msid={playingVideoItem.id}
            imgsize={imgElements.length === 2 ? imgElements[1] : ''}
            playerContainerId={`${playingVideoItem.id}`}
            isPrime={isUserPrime}
            allowDim={false}
            isUserPrime={isUserPrime}
            isContentPrime={isContentPrime}
            isVideoTheatreMinified={this.state.isVideoTheatreMinified}
            store={this.context.store}
            outsideEventListener={(...args) => {
              if (args[1] && args[1][1] === 'VIDEOVIEW') {
                const nextCurrPlayingVideoItem = bottomVideosSliderData.filter(
                  item => item.playerId === args[1][2],
                );
                if (
                  nextCurrPlayingVideoItem &&
                  nextCurrPlayingVideoItem.length > 0
                ) {
                  tthis.setState({
                    playingVideoItem: nextCurrPlayingVideoItem[0],
                    activeSlide: nextCurrPlayingVideoItem[0].id,
                  });
                }
              }
              this.videoEventListener(...args);
            }}
          />
          <p className={s.vdotxt}> {activeSlideTitle}</p>
          {!this.state.isVideoTheatreMinified && (
            <VideoTheaterSlider
              items={bottomVideosSliderData}
              handleSliderCardItem={this.handleSliderCardItem}
              activeSlide={this.state.activeSlide}
              isTablet={isTablet}
            />
          )}
        </div>
      );
    }
    return '';
  }
}
const mapStateToProps = state => ({
  isUserPrime: state.isPrime,
  isVideoTheatreOpen: state.articleshow_v2.isVideoTheatreOpen,
  videoTheatreSliderPath: state.articleshow_v2.videoTheatreSliderPath,
  videoTheatreCurrMsid: state.articleshow_v2.videoTheatreCurrMsid,
  videoTheatreCurrItem: state.articleshow_v2.videoTheatreCurrItem,
  isMiniTvPlayerShown: state.miniTv.showMiniTvPlayer,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  closeVideoTheatre: () => {
    dispatch(closeVideoTheatre());
  },
  openVideoTheatre: () => {
    dispatch(openVideoTheatre());
  },
  addNextVideoMsid: (msidForNextVideo, slikeId) => {
    dispatch(addNextVideoMsid(msidForNextVideo, slikeId));
  },
  deleteDockCandidate: () => {
    dispatch(deleteDockCandidate());
  },
  deleteUnDockCandidate: () => {
    dispatch(deleteUnDockCandidate());
  },
  showMiniTvPlayer: isShown => {
    dispatch(showMiniTvPlayer(isShown));
  },
});
VideoTheater.propTypes = {
  isUserPrime: PropTypes.bool,
  videoTheatreSliderPath: PropTypes.string,
  isVideoTheatreOpen: PropTypes.bool,
  closeVideoTheatre: PropTypes.func.isRequired,
  videoTheatreCurrMsid: PropTypes.string,
  videoTheatreCurrItem: PropTypes.shape({
    primeid: PropTypes.string,
  }),
  addNextVideoMsid: PropTypes.func.isRequired,
  deleteUnDockCandidate: PropTypes.func.isRequired,
  deleteDockCandidate: PropTypes.func.isRequired,
  showMiniTvPlayer: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

VideoTheater.defaultProps = {
  isUserPrime: false,
  videoTheatreSliderPath: '',
  isVideoTheatreOpen: false,
  videoTheatreCurrMsid: '',
  videoTheatreCurrItem: {},
  isMobile: false,
};

VideoTheater.contextTypes = {
  store: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoTheater);
